import ons from "onsenui";
import * as React from "react";
import { isLoading, Loading } from "../Loading";
import { getCSSIOSSuffix } from "../utils/DeviceUtils";
import ScreenSkeletonHeader from "./ScreenSkeletonHeader";

export type TitleBarStyle = "PRIMARY" | "SECONDARY" | "TRANSPARENT";

export interface ScreenSkeletonProps {
  title: JSX.Element | string;
  titleBarStyle: TitleBarStyle;
  onBackClick?: () => void;
  onChatClick?: () => void;
  numNewChatMessages?: number | Loading;
  actionButton?: JSX.Element;
  scrollElemRef?: React.RefObject<HTMLDivElement> | null;
  className?: string;
  rootClassName?: string;
  isClear?: boolean;
  hideHeader?: boolean;
}

export class ScreenSkeleton extends React.Component<ScreenSkeletonProps, {}> {
  static TitleBarStyle = {
    TRANSPARENT: "TRANSPARENT" as const,
    PRIMARY: "PRIMARY" as const,
    SECONDARY: "SECONDARY" as const,
  };

  constructor(props: ScreenSkeletonProps) {
    super(props);
  }

  render() {
    return (
      <div
        className={
          "ScreenSkeleton__root " +
          (this.props.titleBarStyle === ScreenSkeleton.TitleBarStyle.TRANSPARENT
            ? "ScreenSkeleton__rootTransparent"
            : "") +
          (this.props.rootClassName !== undefined ? " " + this.props.rootClassName : "")
        }
        data-ios-suffix={getCSSIOSSuffix()}
        data-is-ios-safari={ons.platform.isIOSSafari()}
      >
        {this.props.hideHeader !== true ? (
          <ScreenSkeletonHeader
            title={this.props.title}
            titleBarStyle={this.props.titleBarStyle}
            actionButton={this.props.actionButton}
            onBackClick={this.props.onBackClick}
          />
        ) : null}
        {this.props.onChatClick === undefined ? (
          ""
        ) : (
          <div
            className={
              "ScreenSkeleton__chatButtonWrapper " +
              (ons.platform.isIOS()
                ? ` ScreenSkeleton__chatButtonWrapper_iOS${getCSSIOSSuffix()} `
                : "") +
              (this.props.titleBarStyle === ScreenSkeleton.TitleBarStyle.SECONDARY
                ? "ScreenSkeleton__chatButtonWrapperSecondary"
                : "ScreenSkeleton__chatButtonWrapperPrimary")
            }
            onClick={this.props.onChatClick}
          >
            <div className="ScreenSkeleton__chatButton" />
            {this.props.numNewChatMessages !== undefined &&
            !isLoading(this.props.numNewChatMessages) &&
            this.props.numNewChatMessages > 0 ? (
              <div className="ScreenSkeleton__chatBadgeIcon">{this.props.numNewChatMessages}</div>
            ) : (
              ""
            )}
          </div>
        )}
        <div
          className={"ScreenSkeleton__body clusterDetailsScrollElement " + this.props.className}
          ref={this.props.scrollElemRef}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}
